import { useMutation } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { patchManageTrendingSeasonQueryFn } from "../../../../../queries/queryFunctions/privetQueryFns/patchQueryFns";
import { useFormik } from "formik";
import Pagination from "../../../ui/Pagination";

function ManageTrendingForm({ data, sites, trendingSeasons, limit ,setLimit, setSkip }) {
  const [activePage, setActivePage] = useState(0);
  const [pageSize, setPageSize] = useState(limit);

  const {
    mutate: manageTrendingSeason,
    isPending: isLoadingMutate,
    isError: isErrorMutate,
  } = useMutation({
    mutationFn: patchManageTrendingSeasonQueryFn,
    async onSuccess(data) {
      toast.success(
        "Manage Trengings success",
      );
    },
    onError(error) {
      toast.error("Something went wrong, please try later!");
    },
  });

  const onSubmit = (data) => {
    manageTrendingSeason(data);
  };

  const { values, handleSubmit, setFieldValue } = useFormik({
    initialValues: {
      summer: [],
      winter: [],
      spring: [],
      autumn: [],
    },
    onSubmit: onSubmit,
  });

  useEffect(() => {
    setFieldValue(
      "summer",
      trendingSeasons?.summer?.map((trend) => trend) || [],
    );
    setFieldValue(
      "winter",
      trendingSeasons?.winter?.map((trend) => trend) || [],
    );
    setFieldValue(
      "spring",
      trendingSeasons?.spring?.map((trend) => trend) || [],
    );
    setFieldValue(
      "autumn",
      trendingSeasons?.autumn?.map((trend) => trend) || [],
    );
  }, [trendingSeasons]);

  const toggleSeasonValue = (season, siteId) => {
    const current = values[season];

    if (current.includes(siteId)) {
      setFieldValue(
        season,
        current.filter((id) => id !== siteId),
      );
    } else {
      setFieldValue(season, [...current, siteId]);
    }
  };

  const handleClick = (pageIndex) => {
    setActivePage(pageIndex);
    const newSkip = pageIndex * limit;
    const newLimit = limit;
    setSkip(newSkip);
    setLimit(newLimit);
  };

  const handleChangePageSize = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setLimit(newSize);
  };

  const startIdx = activePage * limit;
  const endIdx = Math.min(startIdx + limit, data?.[0]?.data?.length);

  return (
    <form onSubmit={handleSubmit}>
      <div
        class='table-responsive'
        style={{
          maxHeight: "400px",
        }}
      >
        <table class='table align-middle text-center mb-4'>
          <thead
            class='border-bottoms bg-white'
            style={{
              position: "sticky",
              zIndex: 2,
              top: 0,
            }}
          >
            <tr class='fw-semibold text-dark'>
              <th class='text-start'>Site</th>
              <th>Summer</th>
              <th>Winter</th>
              <th>Spring</th>
              <th>Autumn</th>
            </tr>
          </thead>

          <tbody>
            {sites?.map((site) => {
              return (
                <tr>
                  <td class='text-start fw-medium'>{site.label}</td>
                  <td>
                    <input
                      class='form-check-input'
                      type='checkbox'
                      checked={values.summer.includes(site.value)}
                      onChange={() => toggleSeasonValue("summer", site.value)}
                    />
                  </td>
                  <td>
                    <input
                      class='form-check-input'
                      type='checkbox'
                      checked={values.winter.includes(site.value)}
                      onChange={() => toggleSeasonValue("winter", site.value)}
                    />
                  </td>
                  <td>
                    <input
                      class='form-check-input'
                      type='checkbox'
                      checked={values.spring.includes(site.value)}
                      onChange={() => toggleSeasonValue("spring", site.value)}
                    />
                  </td>
                  <td>
                    <input
                      class='form-check-input'
                      type='checkbox'
                      checked={values.autumn.includes(site.value)}
                      onChange={() => toggleSeasonValue("autumn", site.value)}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div class='d-flex justify-content-between align-items-center mt-4'>
        <button class='btn btn-danger px-5 py-2 rounded-pill' type='submit'>
          Submit
        </button>
        <Pagination
          startIdx={startIdx}
          endIdx={endIdx}
          pageSize={pageSize}
          activePage={activePage}
          handleClick={handleClick}
          handleChangePageSize={handleChangePageSize}
          data={data}
          limit={limit}
          bookings={data}
          totalCount={data?.[0]?.totalCount}
          itemsPerPage={limit}
        />
      </div>
    </form>
  );
}

export default ManageTrendingForm;
